import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { set_vendor_store } from "../../../redux/actions/StoreAction";
import { apiJson } from "../../../api/Api";
import { set_loading } from "../../../redux/actions/LayoutAction";
import Header from "../subheader/Header";
import MainSlider from "./components/MainSlider";
import ProductCategoryList from "./components/ProductCategoryList";
import ProductList from "./components/ProductList";
import { toast } from "react-toastify";
import "./shop.scss";

const Shop = (props) => {
  const [data, setData] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Shop";
    apiJson.vendorProfile.getVendorProfile().then((response) => {
      setData(true);
      if (response.success) {
        props.set_vendor_store({
          vendorStore: response.data,
          secondaryBanners: response.data.banners.filter(
            (banner) => banner.banner_type === "store_secondary"
          ),
          primaryBanners: response.data.banners.filter(
            (banner) => banner.banner_type === "store_primary"
          ),
        });
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right shop-page-desktop">
        <Header
          heading="Shop"
          search={false}
          filters={{ status: false, date_filter: false }}
        />
        {data && (
          <div className="right-content shop-page-right-content">
            <div className="content-container page-container">
              <div className="content-wrapper">
                <MainSlider />

                <div className="product-category-row">
                  {props.vendorStore?.categories && (
                    <ProductCategoryList
                      categories={props.vendorStore?.categories}
                    />
                  )}
                </div>
                <div className="product-list-row">
                  {props.vendorStore?.products?.length > 5 ? (
                    <Fragment>
                      <ProductList
                        product={props.vendorStore?.products?.slice(0, 5)}
                        type="product"
                      />
                      <ProductList
                        product={props.vendorStore?.products?.slice(
                          5,
                          props.vendorStore?.products?.length
                        )}
                        type="product"
                      />
                    </Fragment>
                  ) : (
                    <ProductList
                      product={props.vendorStore?.products}
                      type="product"
                    />
                  )}
                  {props.vendorStore?.products?.length === 0 && (
                    <div className="no-products-container">
                      <span className="no-products">You Have No Products!</span>
                    </div>
                  )}
                </div>
                <div className="banner-row">
                  <div className="banner-container">
                    {props.secondaryBanners &&
                    props.secondaryBanners.length > 0 ? (
                      <img
                        src={props.secondaryBanners[0].image}
                        alt={props.secondaryBanners[0].type}
                        width="100%"
                        height="300px"
                      />
                    ) : (
                      <img
                        src="http://via.placeholder.com/1000x400"
                        alt="seconday-banner"
                        width="100%"
                        height="300px"
                      />
                    )}
                  </div>
                </div>
                <div className="product-list-row">
                  {props.vendorStore?.services?.length > 5 ? (
                    <Fragment>
                      <ProductList
                        product={props.vendorStore?.services?.slice(0, 5)}
                        type="service"
                      />
                      <ProductList
                        product={props.vendorStore?.services?.slice(
                          5,
                          props.vendorStore?.services?.length
                        )}
                        type="service"
                      />
                    </Fragment>
                  ) : (
                    <ProductList
                      product={props.vendorStore?.services}
                      type="service"
                    />
                  )}
                  {props.vendorStore?.services?.length === 0 && (
                    <div className="no-products-container">
                      <span className="no-services">You Have No Services!</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorStore: state.vendorStore.vendorStore,
    secondaryBanners: state.vendorStore.secondaryBanners,
    primaryBanners: state.vendorStore.primaryBanners,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = {
  set_vendor_store,
  set_loading,
};

export default connect(mapStateToProps, mapDispatchTopProps)(Shop);
